import { useQuery } from '@tanstack/react-query'
import { getJurisdictions, Jurisdiction } from '@/api/filterService'

/**
 * Custom hook for fetching jurisdictions
 *
 * Cached aggressively (1 hour) since jurisdictions rarely change.
 */
export function useJurisdictions() {
  return useQuery({
    queryKey: ['jurisdictions'],
    queryFn: getJurisdictions,
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 2, // 2 hours
    refetchOnWindowFocus: false,
    retry: 2,
  })
}

/**
 * Find jurisdiction by UUID
 */
export function findJurisdictionByUuid(
  jurisdictions: Jurisdiction[],
  uuid: string,
): Jurisdiction | undefined {
  return jurisdictions.find((j) => j.jurisdiction_uuid === uuid)
}

/**
 * Find jurisdictions by UUIDs
 */
export function findJurisdictionsByUuids(
  jurisdictions: Jurisdiction[],
  uuids: string[],
): Jurisdiction[] {
  return jurisdictions.filter((j) => uuids.includes(j.jurisdiction_uuid))
}
